const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/scoring-machines`,
    saveSpeedTable: `${API_URL}/scoring-machine/save-speed-table`
};

export default apiUrls;
